// extracted by mini-css-extract-plugin
module.exports = {"text-regular":"14px","listLabel":"ListLabel-module--listLabel--17841c"};